import type { SVGProps } from 'react';

export type BackArrowProps = SVGProps<SVGSVGElement> & {
  size?: number;
};

export const BackArrow = ({ size = 12, ...rest }: BackArrowProps) => (
  <svg width={size} height={size} viewBox="0 0 14 14" role="img" aria-hidden {...rest}>
    <title>back</title>
    <path
      d="M9 2 L4 7 L9 12"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
